<template>
  <div id="wrap">
    <!-- title -->
    <div class="title">个人3C服务</div>
    <div class="text">同城帮依托海量回收终端与强大二手数码运营能力，为大众提供高性价比的二手机购买、回收到租赁等手机生态链服务。</div>

    <!-- 内容区 -->
    <ul class="content">
      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p4.ssl.qhimg.com/t0105051371575767bc.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">二手优品</div>
          <!-- text -->
          <div
            class="content-bottom-text"
          >依托同城帮人工智能、自动化监测后端能力，臻选出优质二手数码产品，为用户提供优质二手机购买体验与周边服务。同时平台全场180天质保，7天无理由退换等个性化二手机购买体验。</div>
        </div>
      </li>

      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p1.ssl.qhimg.com/t01b18d3ebc1b57f4ad.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">手机回收</div>
          <!-- text -->
          <div class="content-bottom-text">隐私粉碎+高价回收，让您的闲置手机不仅能卖高价，更能卖的放心，无需担心隐私泄露造成的损失。</div>
        </div>
      </li>

      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p0.ssl.qhimg.com/t014083c9500ad97721.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">手机租赁</div>
          <!-- text -->
          <div
            class="content-bottom-text"
          >同城帮联合芝麻信用等第三方授信平台，推出租机授权能力，赋能三方手机商户获得手机租赁能力，提升新机商户手机销量，完善手机产业B端闭环能力。</div>
        </div>
      </li>

      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p3.ssl.qhimg.com/t018ded209f0a94f633.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">PLUS会员服务</div>
          <!-- text -->
          <div class="content-bottom-text">同城帮推出C端二手机PLUS会员服务，普惠二手机购买用户，鼓励用户分享平台优惠，发散平台价值。</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#wrap {
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 40px;
  }
  //   展示区
  .content {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    li {
      width: 478px;
      height: 440px;
      margin-bottom: 50px;
      box-shadow: 0px 2px 15px 0px rgba(0, 57, 44, 0.13);
      .content-top {
        img {
          height: 240px;
          width: 100%;
        }
      }
      .content-bottom {
        // padding: 25px 30px 35px 30px;
        padding: 0 30px;
        box-sizing: border-box;
        .content-bottom-title {
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          color: #000000;
          margin-bottom: 30px;
          margin-top: 25px;
        }
        .content-bottom-text {
          font-size: 16px;
          color: #666666;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
